import { JSX } from 'react'

import { IconProps } from '../../icon'

const Validate: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M39.3751 13.6248C40.2083 14.4579 40.2083 15.8087 39.3751 16.6418L20.8863 35.1307C20.0532 35.9638 18.7024 35.9638 17.8693 35.1307L8.62483 25.8862C7.79172 25.0532 7.79172 23.7024 8.62483 22.8693C9.45794 22.0362 10.8087 22.0362 11.6418 22.8693L19.3778 30.6052L36.3583 13.6248C37.1915 12.7917 38.542 12.7917 39.3751 13.6248Z'
      fill='black'
    />
  </svg>
)

export default Validate
